import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { Button, Card, CardContent, Menu, MenuItem, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router";
import { ContainerGrid, FormModal } from "src/components";
import { useSession } from "src/hooks";
import { useGetForms } from "src/http";
import { UserFeedbackTabs } from "./components";

interface IParams {
  userId: string;
}

const UserFeedbackPage = () => {
  const sessionUser = useSession();
  const { userId } = useParams<keyof IParams>() as IParams;
  const { data: formsData, isLoading: isLoadingForms } = useGetForms();
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const [selectedFormGuid, setSelectedFormGuid] = useState<string | null>(null);
  const [selectedFormSubmissionGuid, setSelectedFormSubmissionGuid] = useState<string | null>(null);

  const isAddButtonDisabled = isLoadingForms || (formsData?.forms.length ?? 0) === 0;
  const addButtonTooltip = !isLoadingForms && (formsData?.forms.length ?? 0) === 0 ? "No forms available" : "";

  return (
    <>
      <Stack spacing={{ xs: 0.75, md: 1 }}>
        <Card>
          <CardContent>
            <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "center" }}>
              <Stack spacing={0.5}>
                <Typography variant="h5">Feedback</Typography>
                <Typography>Create, send and receive reflections and feedback.</Typography>
              </Stack>
              {sessionUser.userId === userId && (
                <Tooltip title={addButtonTooltip}>
                  <span>
                    <Button
                      variant="contained"
                      endIcon={<KeyboardArrowDownRounded />}
                      disabled={isAddButtonDisabled}
                      onClick={(e) => setMenuAnchor(e.currentTarget)}
                    >
                      Add
                    </Button>
                  </span>
                </Tooltip>
              )}
            </Stack>
          </CardContent>
        </Card>

        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
          {formsData?.forms.map((form) => (
            <MenuItem
              key={form.guid}
              onClick={() => {
                setMenuAnchor(null);
                setSelectedFormGuid(form.guid);
              }}
            >
              {form.name}
            </MenuItem>
          ))}
        </Menu>

        <ContainerGrid container>
          <ContainerGrid size={{ sm: 12, md: 8 }} offset={{ md: 2 }}>
            <UserFeedbackTabs
              userId={userId}
              onDraftClicked={(formSubmissionGuid, formGuid) => {
                setSelectedFormGuid(formGuid);
                setSelectedFormSubmissionGuid(formSubmissionGuid);
              }}
            />
          </ContainerGrid>
        </ContainerGrid>
      </Stack>

      <FormModal
        formGuid={selectedFormGuid ?? undefined}
        formSubmissionGuid={selectedFormSubmissionGuid ?? undefined}
        visible={Boolean(selectedFormGuid)}
        onSubmitted={() => {
          setSelectedFormGuid(null);
          setSelectedFormSubmissionGuid(null);
        }}
        onCancelled={() => {
          setSelectedFormGuid(null);
          setSelectedFormSubmissionGuid(null);
        }}
      />
    </>
  );
};

export { UserFeedbackPage };
